var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('div', {
    staticClass: "card card-custom gutter-b",
    staticStyle: {
      "box-shadow": "none"
    }
  }, [_c('div', {
    staticClass: "card-header card-header-tabs-line"
  }, [_c('ul', {
    ref: "builder-tab",
    staticClass: "nav nav-dark nav-bold nav-tabs nav-tabs-line",
    attrs: {
      "role": "tablist"
    }
  }, [_vm._m(0)])]), _c('b-form', {
    staticClass: "form",
    on: {
      "submit": function submit($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('b-tabs', {
    staticClass: "hide-tabs",
    model: {
      value: _vm.tabIndex,
      callback: function callback($$v) {
        _vm.tabIndex = $$v;
      },
      expression: "tabIndex"
    }
  }, [_c('b-tab', {
    attrs: {
      "active": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "documento",
      "label-for": "documento",
      "label": "Documento "
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "30",
      "state": _vm.validateState('documento'),
      "autofocus": ""
    },
    model: {
      value: _vm.$v.form.documento.$model,
      callback: function callback($$v) {
        _vm.$set(_vm.$v.form.documento, "$model", $$v);
      },
      expression: "$v.form.documento.$model"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "historico",
      "label-for": "historico",
      "label": "Descrição"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "50",
      "state": _vm.validateState('historico')
    },
    model: {
      value: _vm.$v.form.historico.$model,
      callback: function callback($$v) {
        _vm.$set(_vm.$v.form.historico, "$model", $$v);
      },
      expression: "$v.form.historico.$model"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "banco",
      "label-for": "banco",
      "label": "Banco"
    }
  }, [_c('b-form-select', {
    model: {
      value: _vm.form.banco,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "banco", $$v);
      },
      expression: "form.banco"
    }
  }, _vm._l(_vm.bancos, function (b) {
    return _c('b-form-select-option', {
      key: b.id_banco + 'bancos',
      attrs: {
        "value": b
      }
    }, [_vm._v(" " + _vm._s(b.nome) + " ")]);
  }), 1)], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Fornecedor",
      "label-for": "form.fornecedor"
    }
  }, [_c('VueSelect', {
    attrs: {
      "label": "id_pessoa",
      "filterable": false,
      "options": _vm.fornecedores
    },
    on: {
      "input": _vm.setCliente,
      "search": _vm.onSearch
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.nome + " - " + option.cnpj_cpf) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.nome + " - " + option.cnpj_cpf) + " ")])];
      }
    }]),
    model: {
      value: _vm.fornecedor,
      callback: function callback($$v) {
        _vm.fornecedor = $$v;
      },
      expression: "fornecedor"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o nome do fornecedor ")])], 2)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "id_plano_contas",
      "label-for": "id_plano_contas",
      "label": "Plano de Contas"
    }
  }, [_c('VueSelect', {
    attrs: {
      "label": "id_plano_contas",
      "filterable": false,
      "options": _vm.plano_contas
    },
    on: {
      "input": _vm.setPlano,
      "search": _vm.onSearchPlano
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.descricao) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.descricao) + " ")])];
      }
    }]),
    model: {
      value: _vm.plano,
      callback: function callback($$v) {
        _vm.plano = $$v;
      },
      expression: "plano"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe a descrição ")])], 2)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('CentroCustoSelect', {
    model: {
      value: _vm.form.id_centro_custo,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "id_centro_custo", $$v);
      },
      expression: "form.id_centro_custo"
    }
  })], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Meio de pagamento",
      "label-for": "form.meio_pagamento"
    }
  }, [_c('VueSelect', {
    attrs: {
      "label": "id_pessoa",
      "filterable": false,
      "options": _vm.meiosDePagamento
    },
    on: {
      "search": _vm.onSearchMeioPagamento
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.descricao) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.descricao) + " ")])];
      }
    }]),
    model: {
      value: _vm.meioPagamento,
      callback: function callback($$v) {
        _vm.meioPagamento = $$v;
      },
      expression: "meioPagamento"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o meio de pagamento ")])], 2)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "data-created_at",
      "label-for": "created_at",
      "label": "Data Emissão "
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "data-vencimento",
      "placeholder": " ",
      "locale": "pt-br",
      "type": "date"
    },
    model: {
      value: _vm.$v.form.created_at.$model,
      callback: function callback($$v) {
        _vm.$set(_vm.$v.form.created_at, "$model", $$v);
      },
      expression: "$v.form.created_at.$model"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "data-vencimento",
      "label-for": "data_vencimento",
      "label": "Data Vencimento "
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date",
      "id": "data-vencimento",
      "placeholder": " ",
      "locale": "pt-br",
      "state": _vm.validateState('data_vencimento')
    },
    model: {
      value: _vm.$v.form.data_vencimento.$model,
      callback: function callback($$v) {
        _vm.$set(_vm.$v.form.data_vencimento, "$model", $$v);
      },
      expression: "$v.form.data_vencimento.$model"
    }
  })], 1)], 1), _vm.form.pago ? _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "data-pagamento",
      "label-for": "data_pagamento",
      "label": "Data Pagamento "
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date",
      "id": "data-vencimento",
      "placeholder": " ",
      "locale": "pt-br"
    },
    model: {
      value: _vm.form.data_pagamento,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "data_pagamento", $$v);
      },
      expression: "form.data_pagamento"
    }
  })], 1)], 1) : _vm._e()], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "valor",
      "label-for": "valor",
      "label": "Valor R$"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.form.valor,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "valor", $$v);
      },
      expression: "form.valor"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "juros",
      "label-for": "juros",
      "label": "Juros R$"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.form.juros,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "juros", $$v);
      },
      expression: "form.juros"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "multa",
      "label-for": "multa",
      "label": "Multa R$"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.form.multa,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "multa", $$v);
      },
      expression: "form.multa"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "desconto",
      "label-for": "desconto",
      "label": "Desconto R$"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.form.desconto,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "desconto", $$v);
      },
      expression: "form.desconto"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "valor_total",
      "label-for": "valor_total",
      "label": "Valor a Pagar R$"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "disabled": ""
    },
    model: {
      value: _vm.valor_total,
      callback: function callback($$v) {
        _vm.valor_total = $$v;
      },
      expression: "valor_total"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1)], 1), _c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "observacao",
      "label": "Observação",
      "label-for": "observacao"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "id": "observacao",
      "name": "observacao",
      "placeholder": "",
      "rows": "4"
    },
    model: {
      value: _vm.form.obs,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "obs", $$v);
      },
      expression: "form.obs"
    }
  })], 1)], 1)], 1), _vm.form.repetir && _vm.isNotEdit ? _c('b-row', {
    attrs: {
      "align-v": "center"
    }
  }, [_c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "vezes",
      "label-for": "vezes",
      "label": "Parcelas"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "vezes",
      "placeholder": " ",
      "locale": "pt-br",
      "type": "number"
    },
    model: {
      value: _vm.form.vezes,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "vezes", _vm._n($$v));
      },
      expression: "form.vezes"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('button', {
    ref: "gerar_parcelas",
    staticClass: "btn btn-primary font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.gerarParcelas
    }
  }, [_vm._v(" Gerar Parcelas ")])])], 1) : _vm._e(), _vm.form.repetir && _vm.isNotEdit ? _c('b-row', [_c('b-col', {
    attrs: {
      "md": "5"
    }
  }, [_c('TableApp', {
    ref: "valor",
    attrs: {
      "item": "pagamento",
      "subTitulo": "",
      "data": _vm.form.parcelas,
      "fields": _vm.fields,
      "classFilterColumn": "valor"
    },
    scopedSlots: _vm._u([{
      key: "customRow",
      fn: function fn(props) {
        return [props.field == 'id' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "nome"
          },
          slot: "nome"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(" " + _vm._s(props.rowData.originalIndex + 1) + " ")])])]) : _vm._e(), props.field == 'valor' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "nome"
          },
          slot: "nome"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          directives: [{
            name: "b-modal",
            rawName: "v-b-modal.modal-pagamento",
            modifiers: {
              "modal-pagamento": true
            }
          }],
          staticClass: "font-weight-bold text-muted cursor-pointer",
          on: {
            "click": function click($event) {
              return _vm.changePagamento(props.rowData.originalIndex);
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.numberToReal(props.rowData.valor, 2)) + " ")])])]) : _vm._e(), props.field == 'vencimento' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "quantidade"
          },
          slot: "quantidade"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          directives: [{
            name: "b-modal",
            rawName: "v-b-modal.modal-calendar",
            modifiers: {
              "modal-calendar": true
            }
          }],
          staticClass: "font-weight-bold text-muted cursor-pointer",
          on: {
            "click": function click($event) {
              return _vm.selectVencimento(props.rowData.originalIndex);
            }
          }
        }, [_vm._v(" " + _vm._s(_vm._f("moment")(props.rowData.data_vencimento, "DD/MM/YYYY")) + " ")])])]) : _vm._e()];
      }
    }], null, false, 1415093359)
  })], 1)], 1) : _vm._e(), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "1"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "status",
      "label-for": "status",
      "label": "Pago"
    }
  }, [_c('span', {
    staticClass: "switch switch-icon"
  }, [_c('label', [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": true,
      "checked": _vm.form.pago
    },
    on: {
      "change": _vm.setAtivo
    }
  }), _c('span')])])])], 1), _c('b-col', [_vm.isNotEdit ? _c('b-form-group', {
    attrs: {
      "id": "repetir",
      "label-for": "repetir",
      "label": "Repetir"
    }
  }, [_c('span', {
    staticClass: "switch switch-icon"
  }, [_c('label', [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": true,
      "checked": _vm.form.repetir
    },
    on: {
      "change": _vm.setRepetir
    }
  }), _c('span')])])]) : _vm._e()], 1)], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "modal-calendar",
      "title": "Ajustar vencimento",
      "size": "sm",
      "centered": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref) {
        var ok = _ref.ok,
          cancel = _ref.cancel;
        return [_c('b-button', {
          on: {
            "click": function click($event) {
              return cancel();
            }
          }
        }, [_vm._v(" Cancelar ")]), _c('b-button', {
          ref: "salvarVencimento",
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.salvarVencimento
          }
        }, [_vm._v(" Salvar ")])];
      }
    }])
  }, [_c('div', {
    staticClass: "mx-auto"
  }, [_c('b-calendar', {
    attrs: {
      "locale": "pt-BR"
    },
    model: {
      value: _vm.vencimentoSelected,
      callback: function callback($$v) {
        _vm.vencimentoSelected = $$v;
      },
      expression: "vencimentoSelected"
    }
  })], 1)]), _c('b-modal', {
    attrs: {
      "id": "modal-pagamento",
      "title": "Ajustar pagamento",
      "size": "sm",
      "centered": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref2) {
        var ok = _ref2.ok,
          cancel = _ref2.cancel;
        return [_c('b-button', {
          on: {
            "click": function click($event) {
              return cancel();
            }
          }
        }, [_vm._v(" Cancelar ")]), _c('b-button', {
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.salvarPagamento
          }
        }, [_vm._v(" Salvar ")])];
      }
    }])
  }, [_c('div', {
    staticClass: "mx-auto"
  }, [_c('b-form', {
    staticClass: "form",
    on: {
      "submit": function submit($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.salvarPagamento.apply(null, arguments);
      }
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "id": "valorPagamento",
      "name": "valorPagamento",
      "value": _vm.valorPagamento
    },
    on: {
      "input": _vm.changePagamentoEdited
    }
  }, 'money', _vm.configMoney, false))], 1)], 1)])], 1)], 1), _c('div', {
    staticClass: "card-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('button', {
    ref: "submit_conta_novo",
    staticClass: "btn btn-primary font-weight-bold",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(" Salvar ")]), _c('router-link', {
    staticClass: "btn btn-clean font-weight-bold",
    attrs: {
      "to": {
        name: 'contasPagarLista'
      }
    }
  }, [_vm._v(" Cancelar ")])], 1)])])])], 1)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "data-tab": "0",
      "data-toggle": "tab",
      "href": "#",
      "role": "tab"
    }
  }, [_vm._v(" Cadastro ")])]);
}];
export { render, staticRenderFns };